module.exports = __webpack_public_path__ + "static/img/layout4.f04388e1.png";